import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/date-picker.css';
import App from './App.tsx';

// Register Arabic font for PDF generation
import { Font } from '@react-pdf/renderer';

// Register the Amiri font for Arabic text support
Font.register({
  family: 'Amiri',
  fonts: [
    {
      src: '/src/assets/fonts/Amiri-Regular.ttf',
      fontWeight: 'normal',
    },
  ],
});

console.log('🚀 Main.tsx loaded');

const rootElement = document.getElementById('root');
console.log('📍 Root element:', rootElement);

if (!rootElement) {
  console.error('❌ Root element not found!');
} else {
  console.log('✅ Root element found, creating React root...');
  
  try {
    const root = createRoot(rootElement);
    console.log('✅ React root created, rendering app...');
    
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
    
    console.log('✅ App rendered successfully');
  } catch (error) {
    console.error('❌ Error creating or rendering app:', error);
  }
}
